module.exports = __webpack_public_path__ + "static/img/1.89dd493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/1.png
// module id = B8ZT
// module chunks = 0